import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import { DispatchEventClient, DispatchEventReportDTO, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const dispatchEventClient = new DispatchEventClient(apiBaseUrl);

function useSubmitDispatchEvent() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<DispatchEventReportDTO, ProblemDetails, number>({
    mutationKey: [queryKeys.DispatchEvent.Submit],
    mutationFn: (reportId: number) => dispatchEventClient.submit(reportId),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useSubmitDispatchEvent;
